import { deepExtract } from 'helpers/deep';

const SET_SELECTED_OFFER = 'classpass/offer/SET_SELECTED_OFFER';
const SET_SUBMITTED_OFFER_PRODUCT_ID = 'classpass/offer/SET_SUBMITTED_OFFER_PRODUCT_ID';
const SET_SUBMITTED_OFFER_URL = 'classpass/offer/SET_SUBMITTED_OFFER_URL';

export const setSelectedOffer = offer => ({ type: SET_SELECTED_OFFER, data: offer });
export const setSubmittedOfferProductId = productId => ({ type: SET_SUBMITTED_OFFER_PRODUCT_ID, data: productId });
export const setSubmittedOfferUrl = url => ({ type: SET_SUBMITTED_OFFER_URL, data: url });

export const selectSelectedOffer = state => deepExtract('offer.selectedOffer', state);
export const selectSubmittedOfferProductId = state => deepExtract('offer.productId', state);
export const selectSubmittedOfferUrl = state => deepExtract('offer.url', state);

const initialState = {
  productId: '',
  selectedOffer: {},
  url: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SELECTED_OFFER:
      return {
        ...state,
        selectedOffer: action.data,
      };
    case SET_SUBMITTED_OFFER_PRODUCT_ID:
      return {
        ...state,
        productId: action.data,
      };
    case SET_SUBMITTED_OFFER_URL:
      return {
        ...state,
        url: action.data,
      };
    default:
      return state;
  }
}
